import React, { useLayoutEffect, useState } from "react";
import L from "leaflet";
import { SubtitleRange } from "./types";
import { getColor, addIntensityLevel } from "./map-utils";

export const Subtitle = ({
  mapRef,
  range: grades,
}: {
  mapRef: React.MutableRefObject<L.Map | undefined>;
  range: SubtitleRange[];
}) => {
  const [subtitle, setSubtitle] = useState();
  useLayoutEffect(() => {
    // @ts-ignore
    setSubtitle(L.control({ position: "bottomleft" }));
  }, []);

  useLayoutEffect(() => {
    if (subtitle) {
      // @ts-ignore
      subtitle.onAdd = () => {
        let div = L.DomUtil.create("div", "map-control map-subtitle");

        const labels = grades.map((grade) => {
          const labelColor = getColor({
            rangeGrades: grades,
            intensity: grade.min,
          });
          const gradeMax = grade.max ? `&ndash; ${grade.max}` : "+";
          const minTxt = grade.minTxt || grade.min;
          const subtitleText = `${minTxt} ${gradeMax}`;

          const subtitle = addIntensityLevel({
            text: subtitleText,
            level: grade.level,
          });

          return `<div class="map-clear-both"><i style="background:${labelColor}"></i> ${subtitle}</div>`;
        });

        div.innerHTML = labels.join("");
        return div;
      };
      // @ts-ignore
      subtitle!.addTo(mapRef.current);
    }
  }, [grades, mapRef, subtitle]);

  return <></>;
};
